// Versão do sistema - obtida da API do backend (centralizada em Escalador_backend/CHANGELOG.md)
export const APP_VERSION = '1.3.22'

function formatarData(data) {
  if (!data) return ''
  const partes = String(data).split('T')[0].split('-')
  if (partes.length === 3) {
    return `${partes[2]}/${partes[1]}/${partes[0]}`
  }
  return data
}

export async function getVersionFromChangelog() {
  try {
    const store = (await import('@/store')).default
    const urlRest = store?.state?.urlRest || ''
    if (urlRest) {
      const response = await fetch(`${urlRest}gerencial/changelog`, {
        headers: {
          'ngrok-skip-browser-warning': '69420',
          'Accept': 'application/json'
        }
      })
      if (response.ok) {
        const logs = await response.json()
        if (Array.isArray(logs) && logs.length > 0) {
          const latest = logs[0]
          const data = formatarData(latest.dataLancamento)
          const ver = latest.versao ? (latest.versao.startsWith('v') ? latest.versao : `v${latest.versao}`) : `v${APP_VERSION}`
          return data ? `${ver} | ${data}` : ver
        }
      }
    }
  } catch (error) {
    // Fallback silencioso
  }
  return `v${APP_VERSION}`
}

export function getVersion() {
  return `v${APP_VERSION}`
}

export default APP_VERSION
